import React from "react";
import { Crown, Medal, X, PartyPopper } from "lucide-react";

const CONFETTI = Array.from({ length: 36 }, (_, i) => i);
const COLORS = ["#6366F1", "#06B6D4", "#EC4899", "#10B981", "#F59E0B", "#8B5CF6"];

export function Podium({ entries, onClose, embedded = false }) {
  const top3 = (entries || []).slice(0, 3);
  if (!top3.length) {
    return (
      <div className="text-center text-slate-300 py-12">No quiz scores to celebrate yet.</div>
    );
  }
  // display order: 2nd, 1st, 3rd
  const slots = [top3[1], top3[0], top3[2]];
  const meta = [
    { h: "h-32 sm:h-40", grad: "from-slate-300 to-slate-400", ring: "ring-slate-300", icon: <Medal className="w-6 h-6 text-slate-100" />, badge: "bg-slate-200 text-slate-700" },
    { h: "h-44 sm:h-56", grad: "from-amber-300 to-amber-500", ring: "ring-amber-300", icon: <Crown className="w-8 h-8 text-amber-100" />, badge: "bg-amber-300 text-amber-900" },
    { h: "h-24 sm:h-32", grad: "from-orange-300 to-orange-500", ring: "ring-orange-300", icon: <Medal className="w-6 h-6 text-orange-100" />, badge: "bg-orange-300 text-orange-900" },
  ];
  const rankLabel = [2, 1, 3];

  const Inner = (
    <div className="relative w-full max-w-3xl mx-auto">
      {/* confetti */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden rounded-3xl">
        {CONFETTI.map((i) => (
          <span key={i} className="absolute block w-2 h-3 rounded-sm animate-fall"
                style={{
                  left: `${(i * 2.8) % 100}%`,
                  top: `-10%`,
                  background: COLORS[i % COLORS.length],
                  animationDelay: `${(i % 12) * 0.25}s`,
                  animationDuration: `${3 + (i % 5) * 0.6}s`,
                }} />
        ))}
      </div>

      <div className="relative text-center mb-8">
        <div className="inline-flex items-center gap-2 text-amber-300 font-display font-extrabold text-2xl sm:text-3xl tracking-tight">
          <PartyPopper className="w-7 h-7" /> Quiz Champions
        </div>
      </div>

      <div className="relative flex items-end justify-center gap-3 sm:gap-6">
        {slots.map((e, i) => e ? (
          <div key={i} className="flex-1 max-w-[10rem] flex flex-col items-center animate-fade-up" style={{ animationDelay: `${i * 0.15}s` }}>
            <div className={`w-14 h-14 rounded-full bg-gradient-to-br ${meta[i].grad} ring-4 ${meta[i].ring} flex items-center justify-center shadow-lg mb-3`}>
              {meta[i].icon}
            </div>
            <div className="font-display font-bold text-white text-lg truncate max-w-full">{e.nickname}</div>
            <div className="font-mono-code text-slate-300 text-sm mb-2">{e.score} pts</div>
            <div className={`w-full ${meta[i].h} rounded-t-2xl bg-gradient-to-b ${meta[i].grad} flex items-start justify-center pt-3 shadow-inner`}>
              <span className={`w-9 h-9 rounded-full ${meta[i].badge} font-display font-extrabold flex items-center justify-center`}>{rankLabel[i]}</span>
            </div>
          </div>
        ) : <div key={i} className="flex-1 max-w-[10rem]" />)}
      </div>
    </div>
  );

  if (embedded) return Inner;

  return (
    <div className="fixed inset-0 z-50 bg-slate-950/95 backdrop-blur-sm flex items-center justify-center p-6" data-testid="podium-overlay">
      <button onClick={onClose} data-testid="podium-close-button"
              className="absolute top-6 right-6 p-2 rounded-xl bg-white/10 hover:bg-white/20 text-white transition-all">
        <X className="w-6 h-6" />
      </button>
      {Inner}
    </div>
  );
}
